import { Endpoints } from '@/api/ApiEndpoints';

const TextConstant = {
	Plural: 'TextConstants',
	Single: 'TextConstant',
	ModalForm: true,
	DefaultSorting: 'ID',
	DefaultSortingType: 'ASC',
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'id',
			dbName: 'id',
			label: 'ID',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'key',
			dbName: 'key',
			label: 'Key',
			sortable: true,
			required: true,
			type: 'text',
		},
		
		
	],
	Filters: [],
	PrimaryKey: 'id',
	Actions: {
		addLink: '/TextConstant/add/',
		editLink: '/TextConstant/edit/',
		deleteLink: '/TextConstant/delete/',
	},
};

export default TextConstant;
